import Image from "next/image";

import bannerboy from "../../public/images/home/bannerboy.png";

const MainDemoBanner = ({ showImage = true }) => {
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12 pb--120 pt--70 space-responsive-xxl">
            <div className="content">
              <div className="inner">
                {/* <div className="rbt-new-badge rbt-new-badge-one">
                  <span className="rbt-new-badge-icon">🏆</span> The Leader in
                  Online Learning
                </div> */}

                <h1 className={`title ${!showImage && "text-white"}`}>
                  Don’t Just Study Abroad <br /> Build Your Future Abroad
                </h1>
                <p className="description">
                  Free 1:1 Counselling Sessions with{" "}
                  <strong> Immigration Gurus:</strong> Just a Call Away to
                  Plan your Study Abroad Journey!
                </p>
                <div
                  className="slider-btn"
                  style={{
                    marginTop: "10%",
                  }}
                >
                  <div
                    className="rbt-btn btn-gradient hover-icon-reverse"
                    // href="#"
                  >
                    <span className="icon-reverse-wrapper">
                      <span
                        className="btn-text"
                        onClick={(e) => {
                          e.stopPropagation();
                          const section =
                            document.getElementById("contact-form");
                          if (section) {
                            const topOffset =
                              section.getBoundingClientRect().top +
                              window.pageYOffset -
                              300; // 100px above
                            window.scrollTo({
                              top: topOffset,
                              behavior: "smooth",
                            });
                          }
                        }}
                      >
                        Contact Us
                      </span>
                      <span className="btn-icon">
                        <i className="feather-arrow-right"></i>
                      </span>
                      <span className="btn-icon">
                        <i className="feather-arrow-right"></i>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              {showImage && (
                <div
                  className="shape-wrapper d-flex align-items-center justify-content-center text-center"
                  id="scene"
                >
                  <Image
                    src={bannerboy}
                    width={650}
                    height={1400}
                    alt="Hero Image"
                  />
                  <div
                    className="hero-bg-shape-1 layer"
                    data-depth="0.4"
                    style={{
                      zIndex: 10,
                    }}
                  >
                    {/* <Image
                    src={boy}
                    width={428}
                    height={1400}
                    alt="Hero Image Background Shape"
                  /> */}
                  </div>
                </div>
              )}

              <div className="banner-card pb--60 swiper rbt-dot-bottom-center banner-swiper-active">
                {/* <HomeCourses start={0} end={3} /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MainDemoBanner;
